"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

exports.__esModule = true;
exports.Tokenizer = void 0;

var errors_1 = require("./errors");

var Terms_1 = require("./Terms");

var lookup_1 = require("./Terms/lookup");

var Token_1 = require("./Token");

var Tokenizer = function () {
  function Tokenizer() {}

  Tokenizer.run = function (rule) {
    var _this = this;

    var words = rule.split(' ');
    var parts = [];
    words.map(function (word) {
      var letters = word.split('');
      var buffer = [];
      letters.map(function (letter) {
        switch (letter) {
          case Terms_1.Falsy.value:
          case Terms_1.GroupClose.value:
          case Terms_1.GroupOpen.value:
            {
              if (buffer.length) {
                parts.push(buffer.join(''));
                buffer = [];
              }

              parts.push(letter);
              return;
            }

          default:
            buffer.push(letter);
        }
      });

      if (buffer.length) {
        parts.push(buffer.join(''));
      }
    });
    var tokens = parts.map(function (word, index) {
      return _this.tokenize(word, index);
    });
    this.contextualize(tokens);
    return tokens;
  };

  Tokenizer.contextualize = function (tokens) {
    tokens.map(function (token, index) {
      try {
        switch (token.value) {
          case Terms_1.Falsy.value:
          case Terms_1.Not.value:
            {
              var id = tokens[index + 1];

              if (!Terms_1.Id.is(id)) {
                throw new errors_1.TokenizerError("Unexpected token '" + id.value + "' found tokenizing " + token.value);
              }

              id.Falsy = true;
              break;
            }

          case Terms_1.Force.value:
            {
              var id = tokens[index + 1];

              if (Terms_1.Not.is(id)) {
                id = tokens[index + 2];
              }

              if (!Terms_1.Id.is(id)) {
                throw new errors_1.TokenizerError("Unexpected token '" + id.value + "' found tokenizing " + token.value);
              }

              id.Force = true;
              break;
            }

          case Terms_1.Enable.value:
          case Terms_1.Disable.value:
          case Terms_1.Hide.value:
          case Terms_1.Show.value:
            {
              var id = tokens[index + 1];
              id.Modifier = true;
              break;
            }

          case Terms_1.Modify.value:
            {
              var id = tokens[index + 1];
              var property = tokens[index + 2];
              var value = tokens[index + 4];

              switch (value.value) {
                case '#arr':
                case '#bool':
                case '#int':
                  var typing = tokens[index + 4];
                  value = tokens[index + 5];
                  value.value = Terms_1.Typing.opts.cast(typing.value, value.value);
                  typing.token = Terms_1.Typing.token;
              }

              id.Modifier = true;
              property.token = Terms_1.Property.token;
              value.token = Terms_1.Value.token;
              break;
            }
        }
      } catch (e) {
        console.warn("Error tokenizing word '" + token.value + "'. Rule might not be parsed correctly...", e);
      }

      return token;
    });
  };

  Tokenizer.tokenize = function (word, index) {
    var Term = lookup_1.lookup.byValue(word.toLowerCase());

    if (Term) {
      return new Token_1.Token(Term, word, {}, index);
    }

    return new Token_1.Token(Terms_1.Id.token, word, {}, index);
  };

  Tokenizer.toJson = function (tokens) {
    return tokens.map(function (token) {
      return token.toJson();
    });
  };

  return Tokenizer;
}();

exports.Tokenizer = Tokenizer;